/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 20:02:28
 * @LastEditors: chenhongwei chenhw2019@gmail.com
 * @LastEditTime: 2023-05-12 22:31:51
 */
import * as types from '../../../mutation-types';

export default {
	[types.TEAM_CONFIG](state, obj) {
		state.vuex_teamConfig = obj;
		localStorage.setItem('vuex_teamConfig', JSON.stringify(obj));
	},
};
